<template>
  <div class="container">
    <div>
      <el-form
        inline
        size="mini"
        label-width="45px"
        class="table-search-part"
        @submit.native.prevent="handleQuery()"
      >
        <div>
          <el-form-item label="Running Time" label-width="120px">
            <el-date-picker
              v-model="runningTime"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              :default-time="['00:00:00', '23:59:59']"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="Start time"
              end-placeholder="End time"
              :picker-options="pickerOptions"
              @change="runningTimeDate"
              :clearable="false"
            />
          </el-form-item>
          <el-form-item label="Sport">
            <el-select
              v-model="queryData.sportId"
              placeholder="Sport"
              :popper-append-to-body="false"
              @change="changeSport"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in sportList"
                :key="item.sportId"
                :label="item.sportName"
                :value="item.sportId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Period">
            <el-select
              v-model="queryData.period"
              placeholder="Period"
              :popper-append-to-body="false"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in periodList"
                :key="item.code"
                :label="item.shortName"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Market Type">
            <el-select
              v-model="queryData.marketType"
              placeholder="Market Type"
              :popper-append-to-body="false"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in marketList"
                :key="item.marketType"
                :label="item.marketName"
                :value="item.marketType"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Match ID">
            <el-input
              type="number"
              class="last-input"
              clearable
              v-model="queryData.matchId"
              placeholder="Match ID"
            ></el-input>
          </el-form-item>
          <el-button class="search-btn" @click="handleQuery()">Search</el-button>
          <el-button class="lebel-risk-export-btn" id="download" @click="handleExport()">Download</el-button>
        </div>
      </el-form>
    </div>
    <div class="syslog-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        stripe
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="index" label="Match ID" width="110" align="center">
          <template v-slot="{ row }">
            <div>{{ row.matchId }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sportName" label="Sport" min-width="112">
          <template v-slot="{ row }">
            <div>{{ row.sportName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="openTime" label="Running Time" min-width="150">
          <template v-slot="{ row }">
            <div v-if="row.openTime">{{ formatUtc(row.openTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Tournament" min-width="245">
          <template v-slot="{ row }">
            <div>{{ row.tournamentName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Match" min-width="245">
          <template v-slot="{ row }">
            <div>{{ row.matchName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Period" min-width="90">
          <template v-slot="{ row }">
            <div>{{ row.periodName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Market Type" min-width="110">
          <template v-slot="{ row }">
            <div>{{ row.marketName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Major Line(before)" min-width="120">
          <template v-slot="{ row }">
            <div v-if="row.sportId === 1">
              <div
                v-if="row.marketType == 1007"
              >{{ row.beforeMarket.ouLine }}（{{ row.beforeMarket.overPrice }},{{ row.beforeMarket.underPrice }}）</div>
              <div
                v-if="row.marketType == 1000"
              >{{ row.beforeMarket.ahcLine }}（{{ row.beforeMarket.homePrice }},{{ row.beforeMarket.awayPrice }}）</div>
            </div>
            <div v-if="row.sportId === 3">
              <div
                v-if="row.marketType == 3003"
              >{{ row.beforeMarket.ouLine }}（{{ row.beforeMarket.overPrice }},{{ row.beforeMarket.underPrice }}）</div>
              <div
                v-if="row.marketType == 3002"
              >{{ row.beforeMarket.ahcLine }}（{{ row.beforeMarket.homePrice }},{{ row.beforeMarket.awayPrice }}）</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Major Line(After)" min-width="120">
          <template v-slot="{ row }">
            <div v-if="row.sportId === 1">
              <div
                v-if="row.marketType == 1007"
              >{{ row.alarmMarket.ouLine }}（{{ row.alarmMarket.overPrice }},{{ row.alarmMarket.underPrice }}）</div>
              <div
                v-if="row.marketType == 1000"
              >{{ row.alarmMarket.ahcLine }}（{{ row.alarmMarket.homePrice }},{{ row.alarmMarket.awayPrice }}）</div>
            </div>
            <div v-if="row.sportId === 3">
              <div
                v-if="row.marketType == 3003"
              >{{ row.alarmMarket.ouLine }}（{{ row.alarmMarket.overPrice }},{{ row.alarmMarket.underPrice }}）</div>
              <div
                v-if="row.marketType == 3002"
              >{{ row.alarmMarket.ahcLine }}（{{ row.alarmMarket.homePrice }},{{ row.alarmMarket.awayPrice }}）</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Major Line Move Time" min-width="150">
          <template v-slot="{ row }">
            <div v-if="row.majorLineMoveTime">{{ formatUtc(row.majorLineMoveTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Remark" :show-overflow-tooltip="true" prop="remark" min-width="201"></el-table-column>
        <el-table-column label="Operator" min-width="100">
          <template v-slot="{ row }">
            <div>{{ row.operator }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Operation" min-width="430">
          <template v-slot="{ row }">
            <div style="display: flex;">
              <div style="margin-right:10px;">
                <el-button class="table-inner-btn view-order-btn" @click="handleCheck(row)">Remark</el-button>
              </div>
              <div style="margin-right:10px;">
                <el-button
                  class="table-inner-btn view-order-btn"
                  @click="sendToElectronPage(row)"
                >Odds History</el-button>
              </div>
              <div>
                <el-button
                  class="table-inner-btn view-order-btn"
                  style="width:140px;"
                  @click="sendToElectronPage1(row)"
                >Order Management</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加label1 修改riskLevel2 -->
      <div class="select-down-wrapper">
        <el-form label-width="80px" :label-position="'top'">
          <!-- 修改用户备注 -->
          <el-form-item>
            <div class="remark-warp">
              <el-input
                style="border: 1px solid #DCDFE6;border-radius: 4px;"
                type="textarea"
                :rows="14"
                maxlength="240"
                show-word-limit
                placeholder="Input"
                v-model="remark"
                resize="none"
              />
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
          <el-button class="search-btn" @click="handleRemarkSave()">Save</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import dia from "@/components/dialog/index";
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";
import {
  getAlarmList,
  getAlarmUpdate,
  getAlarmExport,
  getFindSportList,
  getFindMarketListBySport,
  getFindPeriodsBySportId
} from "@/api/ip";
//const { ipcRenderer } = require("electron");
export default {
  name: "IPList",
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      runningTime: [],
      title: "",
      id: "",
      remark: "",
      sportList: [],
      periodList: [],
      marketList: [],
      queryData: {
        current: 1,
        size: 50,
        sportId: "",
        matchId: "",
        period: "",
        marketType: "",
        openTimeStart: "",
        openTimeEnd: ""
      },
      showOverflow: false,
      tableHeight: window.innerHeight,
      pickerOptions: {
        disabledDate(time) {
          let _now =
              new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 * 2 -
              1,
            month = 61 * 24 * 60 * 60 * 1000,
            monthDays = _now - month;
          return time.getTime() > _now || time.getTime() < monthDays;
        }
      }
    };
  },
  watch: {
    "queryData.sportId"(val) {
      if (!val) {
        this.periodList = [];
        this.marketList = [];
        this.queryData.period = "";
        this.queryData.marketType = "";
      }
    }
  },
  methods: {
    changeSport(val) {
      if (val) {
        this.queryData.period = "";
        this.queryData.marketType = "";
        this.fetchPeriodSelectList(val);
        this.fetchMarketSelectList(val);
      }
    },
    async fetchPeriodSelectList(val) {
      try {
        const res = await getFindPeriodsBySportId([val]);
        if (res.data) {
          const data = res.data || [];
          this.periodList = data.filter(id =>
            ["1001", "1002", "3001", "3003"].includes(id.code)
          );
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
      } catch (error) {
        this.periodList = [];
      }
    },
    async fetchMarketSelectList(val) {
      try {
        const res = await getFindMarketListBySport([val]);
        if (res.data) {
          const data = res.data || [];
          this.marketList = data.filter(id =>
            [1000, 1007, 3002, 3003].includes(id.marketType)
          );
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
      } catch (error) {
        this.marketList = [];
      }
    },
    handleExport() {
      const timeZone = this.$moment().utcOffset() / 60;
      const param = { ...this.queryData, timeZoneOffset: timeZone };
      getAlarmExport(param, "export.xlsx");
    },
    handleCheck(data) {
      this.id = data.id;
      this.remark = data.remark;
      this.title = "Remark";
      this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "500px");
    },
    async handleRemarkSave() {
      //this.form.remark = this.remark;
      try {
        const res = await getAlarmUpdate({ id: this.id, remark: this.remark });
        if (res.code == 0) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
      } catch (error) {}
      this.remark = "";
      this.id = "";
      this.Close();
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getAlarmList(this.queryData);
        if (res.data) {
          const data = res.data || {};
          this.list = data.records || [];
          this.total = data.total;
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getFindSportList() {
      try {
        const res = await getFindSportList({});
        if (res.data) {
          const data = res.data || [];
          this.sportList = data.filter(id => [1, 3].includes(id.sportId));
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
      } catch (error) {
        this.sportList = [];
      }
    },
    runningTimeDate([startTime, endTime]) {
      this.queryData.openTimeStart = startTime;
      this.queryData.openTimeEnd = endTime;
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // electron通讯方法(向客户端发送消息)
    sendToElectronPage(params) {
      if (window.require("electron")) {
        let ipcRenderer = window.require("electron").ipcRenderer;
        ipcRenderer.send(
          "createWindow",
          "odds-history",
          `matchId=${params.matchId}&marketType=${params.marketType}&period=${params.period}`
        );
      }
    },
    sendToElectronPage1(params) {
      if (window.require("electron")) {
        let ipcRenderer = window.require("electron").ipcRenderer;
        ipcRenderer.send(
          "createWindow",
          "order-management",
          `matchId=${params.matchId}&marketType=${params.marketType}&period=${params.period}`
        );
      }
    }
  },
  components: {
    dia,
    Empty
  },
  mounted() {
    let d = [];

    // 获取昨天、今天和明天的时间戳
    const today = new Date(new Date().toLocaleDateString()).getTime();
    const yesterday = today - 24 * 60 * 60 * 1000;
    const tomorrow = today + 2 * 24 * 60 * 60 * 1000 - 1;

    d = [yesterday, tomorrow];

    this.runningTime = d;
    this.queryData.openTimeStart = d[0];
    this.queryData.openTimeEnd = d[1];
    this.getFindSportList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.table-search-part {
  margin-top: 20px;
  padding: 0;
  .el-form-item--mini.el-form-item {
    margin-bottom: 18px;
  }
  .el-input__inner {
    width: 270px;
  }
  .el-input {
    width: 130px !important;
  }
}
.last-input {
  margin: 0 20px 0 0 !important;
}
.re-ip-name {
  color: #e1554f;
}
.userId-item::after {
  display: inline-block;
  content: ",";
}
.userId-item:last-child {
  &::after {
    display: none;
  }
}
/deep/.el-form-item__label {
  width: 60px !important;
}
</style>
